import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterModuleEntity } from './m-sfp-smart-filter-module.entity';
import { MSfpSmartFilterEntity } from './m-sfp-smart-filter.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('fk__rbac_role__id', ['fkRbacRoleId'], {})
@Index('fk_m_sfp_smart_filter__id', ['fkMSfpSmartFilterId'], {})
@Index('fk_m_sfp_smart_filter_module__id', ['fkMSfpSmartFilterModuleId'], {})
@Entity(
	'm_sfp_smart_filter__rbac_role',
	{},
	{ label: 'Smart Filter RBAC Role' },
)
export class MSfpSmartFilterRbacRoleEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_m_sfp_smart_filter__id',
		nullable: true,
		unsigned: true,
	})
	public fkMSfpSmartFilterId!: number | null;

	@Column('int', { name: 'fk__rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;

	@Column('int', {
		name: 'fk_m_sfp_smart_filter_module__id',
		nullable: true,
		unsigned: true,
	})
	public fkMSfpSmartFilterModuleId!: number | null;

	@Column('smallint', { name: 'sortOrder' })
	public sortOrder!: number;

	@Column('longtext', { name: 'workdComponentInputOverrides', nullable: true })
	public workdComponentInputOverrides!: string | null;

	@Column('longtext', { name: 'countQueryOverrides', nullable: true })
	public countQueryOverrides!: string | null;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('longtext', { name: 'stateRangesOverride', nullable: true })
	public stateRangesOverride!: string | null;

	@ManyToOne(
		() => RbacRoleEntity,
		(rbacRole) => rbacRole.mSfpSmartFilterRbacRoles,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: 'fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;

	@ManyToOne(
		() => MSfpSmartFilterModuleEntity,
		(mSfpSmartFilterModule) => mSfpSmartFilterModule.mSfpSmartFilterRbacRoles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: 'fk_m_sfp_smart_filter_module__id', referencedColumnName: 'id' },
	])
	public fkMSfpSmartFilterModule!: MSfpSmartFilterModuleEntity;

	@ManyToOne(
		() => MSfpSmartFilterEntity,
		(mSfpSmartFilter) => mSfpSmartFilter.mSfpSmartFilterRbacRoles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: 'fk_m_sfp_smart_filter__id', referencedColumnName: 'id' },
	])
	public fkMSfpSmartFilter!: MSfpSmartFilterEntity;
}
